import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { DialogReferenceDeviceMovementComponent } from 'app/dialogs/dialog-reference-device-movement/dialog-reference-device-movement.component';
import { ReferenceDeviceMovementService } from 'app/services/models/reference-device-movement.service';
import { link } from 'fs';

@Component({
  selector: 'app-reference-detail',
  templateUrl: './reference-detail.component.html',
  styleUrls: ['./reference-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReferenceDetailComponent implements OnInit {
  public contentHeader = null;
  rows: any[] = [];
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption = 5;
  totalCount: number = 0;
  public ColumnMode = ColumnMode;

  deviceId: number = null;
  constructor(
    private activadetRouter: ActivatedRoute,
    private referenceDeviceMovementService: ReferenceDeviceMovementService,
    private modalService: NgbModal
  ) { }

  async ngOnInit() {
    this.activadetRouter.params.subscribe(async params => {
      this.deviceId = params['id']
      await this.getByIdDeviceReferenceMovements(this.pageBasic - 1, this.selectedSize, params['id']);
    });

    this.referenceDeviceMovementService.event$.subscribe(result => {
      this.activadetRouter.params.subscribe(async params => {
        await this.getByIdDeviceReferenceMovements(this.pageBasic - 1, this.selectedSize, params['id']);
      });
    })

    this.contentHeader = {
      headerTitle: 'Referans Cihazlar',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Referans Cihaz Listesi',
            isLink: true,
            link: '/admin/device-reference'
          },
          {
            name: 'Referans Cihaz Detayı',
            isLink: false
          }
        ]
      }
    }
  }

  async getByIdDeviceReferenceMovements(page, size, id) {
    const data = await this.referenceDeviceMovementService.getByIdDeviceReferenceMovement(page, size, id);
    console.log(data);
    this.rows = data.refrences;
    this.totalCount = data.totalCount;
  }

  showReferenceDeviceDialog(id) {
    const modal = this.modalService.open(DialogReferenceDeviceMovementComponent, {
      size: 'sm',
      windowClass: id ? 'modal modal-warning' : 'modal modal-success'
    });
    modal.componentInstance.data = {
      id: id,
      deviceId: this.deviceId,
      message: id ? 'Kalibrasyon Güncelle' : "Kalibrasyon Oluştur"
    };
  }
}